export default function OregonMap() {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.56 78.42L1.88 68.04l4.68-15.85L8.58 27.7 12.48.82h7.3l6.14 3 1.59 8.74 8.81 1.77 7.86-1.77 7.85 1.77 3.78-3.54h8.03l4.98-2.23 7.44-1.8h25.76l6.56 5.8-3.77 12.87-5.72 11.1 4.19 3.09-1.26 6.43v32.37H6.56z"
        fill="#D0E1F7"
      />
      <circle cx="26.76" cy="21.05" r="2.76" fill="#2B75D2" />
      <circle cx="33.67" cy="24.51" r="2.76" fill="#2B75D2" />
      <circle cx="79.67" cy="16.51" r="2.76" fill="#2B75D2" />
      <circle cx="28.14" cy="30.04" r="2.76" fill="#2B75D2" />
      <circle cx="35.05" cy="65.29" r="2.76" fill="#2B75D2" />
      <circle cx="19.85" cy="44.55" r="2.76" fill="#2B75D2" />
      <circle cx="55.79" cy="44.55" r="2.76" fill="#2B75D2" />
    </>
  );
}
